import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Loader from 'components/Loader';
import InputWrapper from './InputWrapper';
import InputInner from './InputInner';
import {
  Button,
  Fader,
  IconArrowRight,
  Inner,
  Label,
  LabelInner
} from './FieldText.style';

const propTypes = {
  name: PropTypes.string,
  isActive: PropTypes.bool,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  InputComponent: PropTypes.func,
  input: PropTypes.shape(),
  className: PropTypes.string,
  label: PropTypes.node
};

const FieldText = props => {
  const { input, className, label, ...rest } = props;
  const isActive = props.isActive || input.value.length;
  const styleName = classnames(className, { 'is-active': isActive });
  const InputComponent = props.InputComponent ? InputWrapper : InputInner;

  return (
    <Inner className={styleName} htmlFor={input.name}>
      <InputComponent {...input} disabled={rest.isLoading} {...rest} />

      <Fader htmlFor={input.name} />
      <Label htmlFor={input.name}>
        <LabelInner>{label}</LabelInner>
      </Label>
      <Button
        type="submit"
        className="loading"
        disabled={rest.isLoading}
        title="Далее"
      >
        {rest.isLoading ? (
          <Loader />
        ) : (
          <IconArrowRight className="FieldText-icon" />
        )}
      </Button>
    </Inner>
  );
};

FieldText.propTypes = propTypes;

export default FieldText;
